import '@splidejs/splide/css'
import Splide from '@splidejs/splide'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/all'

import { wfSliderArrows, wfTabs, addSplideClasses, sel, selAll, addStaticSplideClasses, selector, mm, splideCarousel, connectSplideArrows } from './utils'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

gsap.registerPlugin(ScrollTrigger)

export default function Tabs() {
  function tabsInit() {
    const name = 'tabs'
    addSplideClasses(name + '__slider-thumb')
    const splide = new Splide('.' + name + '__slider-thumb', {
      perPage: 5,
      perMove: 5,
      gap: 0,
      padding: '0rem',
      // autoplay: true,
      direction: 'ttb',
      height: '20rem',
      type: 'loop',
      isNavigation: true,
      pagination: false,
      arrows: false,
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      speed: 1500,
      updateOnMove: true,
      focus: 'center',
      breakpoints: {
        768: {
          height: '10rem',
          perPage: 3,
          perMove: 3,
        },
      },
    })

    addSplideClasses(name + '__slider')
    const img = new Splide('.' + name + '__slider', {
      type: 'fade',
      pagination: false,
      arrows: false,
    })
    img.mount()
    splide.mount()
    splide.sync(img)
    // splide.mount({ AutoScroll })
    connectSplideArrows(splide, '.tabs__arrows')
  }
  tabsInit()
}
